import { createContext, useContext, useState, ReactNode } from "react";
import styled, { keyframes } from "styled-components";

type Ctx = { loading: boolean; start: () => void; stop: () => void };
const C = createContext<Ctx | null>(null);

export function GlobalLoadingProvider({ children }: { children: ReactNode }) {
  const [loading, set] = useState(false);
  return (
    <C.Provider
      value={{ loading, start: () => set(true), stop: () => set(false) }}
    >
      {children}
      {loading && <Overlay />}
    </C.Provider>
  );
}

export function useGlobalLoading() {
  const ctx = useContext(C);
  if (!ctx) throw new Error("useGlobalLoading fora do provider");
  return ctx;
}

const spin = keyframes`to { transform: rotate(360deg); }`;
const Wrap = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(2px);
  display: grid;
  place-items: center;
`;
const Dot = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 4px solid ${({ theme }) => theme.THEME.white};
  border-top-color: ${({ theme }) => theme.THEME.neonBlue};
  animation: ${spin} 0.9s linear infinite;
`;
const Overlay = () => (
  <Wrap>
    <Dot />
  </Wrap>
);
